<template>
  <div :class="$style['goods-detail-divide']">
    <pt-sub-title title="商品划分"></pt-sub-title>
    <table>
      <pt-form-list-item label="经营类型：">{{goodsData.goods_belong}}</pt-form-list-item>
      <pt-form-list-item label="商品类型：">{{goodsData.typeName}}</pt-form-list-item>
      <pt-form-list-item label="地区：">{{goodsData.address}}</pt-form-list-item>
      <pt-form-list-item label="事业部：">{{goodsData.businessDepartmentName}}</pt-form-list-item>
      <pt-form-list-item label="分子公司：">{{goodsData.molecularCompany}}</pt-form-list-item>
      <!-- <pt-form-list-item label="是否在商城展示：">
         <el-switch disabled v-model="goodsData.mallVisible"></el-switch>
      </pt-form-list-item>
      <pt-form-list-item label="是否在首页展示：">
         <el-switch disabled v-model="goodsData.recommend"></el-switch>
      </pt-form-list-item> -->
      <pt-form-list-item label="兑换数量限制：">
        {{pointsGoodsQuota}}
       </pt-form-list-item>
      <pt-form-list-item label="可兑换等级：">
          <table>
            <tr>
              <td :class="$style['integral-goods-of-leval']">等级</td>
              <td>兑换积分系数</td>
            </tr>
            <tr v-for="(item,index) in goodsData.pointsExchangeData" :key="index">
              <td :class="$style['integral-goods-of-leval']">{{item.name}}</td>
              <td>{{item.canBuy?"*"+item.magnification:"不可兑换"}}</td>
            </tr>
          </table>
      </pt-form-list-item>
    </table>
  </div>
</template>
<script>
export default {
  props: {
    goodsData: Object,
    pointsGoodsQuota: String
  }
}
</script>
<style module lang="less">
.goods-detail-divide {
}
.integral-goods-of-leval {
  padding: 0 5px;
}
</style>
